import * as d3 from 'd3'
import ResponsiveSVG from './ResponsiveSVG'

const IMAGE_SCALE = 1.75
const TRANSITION_DURATION = 250
const VELOCITY_DECAY = 0.38
const CIRCLE_LIMIT = 160
const FRAG_ICON_SIZE = 20

const { fileTemplateUrl } = window.JMO;
// const IMAGE_PATH = './images/'

function is_sp() {
  return window.innerWidth < window.JMOSettings.BREAKPOINT
}
function setCenter(target) {
  if (is_sp()) {
    return 'translate(' + [target.width * 0.5, target.width * 1.07] + ')'
  } else {
    return 'translate(' + [target.width * 0.625, target.height * 0.5] + ')'
  }
}
function calcRadius(d, maxMatched, { circle_min, circle_max, circle_exp }) {
  if (d.matched >= window.JMOSettings.chart.THRESHOLD) {
    const max = circle_min + circle_max
    const amped = easeInOut(d.matched / Math.max(maxMatched, 1.0), circle_exp) * max
    const add = d.matched * circle_max * 0.2
    const limit = CIRCLE_LIMIT
    d.r = Math.min(circle_min + amped + add, limit)
  } else {
    d.r = 0
  }
}
function calculateRadius(d, maxMatched, { circle_min, circle_max, circle_exp }) {
  let r
  if (d.matched >= window.JMOSettings.chart.THRESHOLD) {
    const max = circle_min + circle_max
    const amped = easeInOut(d.matched / Math.max(maxMatched, 1.0), circle_exp) * max
    const add = d.matched * circle_max * 0.2
    const limit = CIRCLE_LIMIT
    r = Math.min(circle_min + amped + add, limit)
  } else {
    r = 0
  }
  return r
}
function keyFunction(d) {
  return d.sku
}
function easeInOut(t, _exp) {
  const exp = _exp || 4
  return t < 0.5 ? Math.pow(t * 2, exp) * 0.5 : (1 - Math.pow(1 - (t - 0.5) * 2, exp)) * 0.5 + 0.5
}

class D3_Chart extends ResponsiveSVG {
  constructor(e) {
    super()
    this.node = null
    this.simulation = null
    this.$prevTarget = null
    this.$currentTarget = null
  }
  init(data) {
    this.data = data

    this.dragstarted = d => {
      this.simulate()
      d.fx = d.x
      d.fy = d.y
    }

    this.dragged = d => {
      d.fx = d3.event.x
      d.fy = d3.event.y
    }

    this.dragended = d => {
      d.fx = null
      d.fy = null
    }
    this.buildNodes()
    this.buildElements()
    this.simulate()
    this.draw()

    this.handleResize = () => {
      this.el.select('.container').attr('transform', setCenter(this))

      const infowindowSize = is_sp() ? window.innerWidth * 0.933333333 : 480
      d3.selectAll('.detail_wrapper')
        .attr('width', infowindowSize)
        .attr('height', infowindowSize)
        .attr('x', infowindowSize * -0.5)

      d3.selectAll('.detail')
        .attr('width', infowindowSize)
        .attr('height', infowindowSize)
    }
    this.on('resize', this.handleResize)
  }
  simulate() {
    if (this.simulation) {
      this.simulation.stop()
    }

    this.simulation = d3
      .forceSimulation()
      .velocityDecay(VELOCITY_DECAY)
      .force(
        'collide',
        d3
          .forceCollide(d => {
            return d.r
          })
          .iterations(16)
      )
      .force('charge', d3.forceManyBody())
      .force('y', d3.forceY(0))
      .force('x', d3.forceX(0))

    this.simulation.nodes(this.data.children, keyFunction).on('tick', () => {
      this.nodes.attr('transform', d => {
        return 'translate(' + [d.x, d.y] + ')'
      })
    })
  }

  buildNodes(maxMatched) {
    this.data.children.forEach(d => {
      calcRadius(d, this.data.maxMatched, this.params)
    })

    const container = this.el
      .append('g')
      .classed('container', true)
      .attr('transform', setCenter(this))

    this.nodes = container
      .selectAll('.product')
      .data(this.data.children, keyFunction)
      .enter()
      .append('g')
      .attr('class', 'product')
      .attr('id', d => {
        return 'product_' + d.sku
      })
      .on('click', e => this.onClick(e))

    if (!is_sp()) {
      this.nodes.call(
        d3
          .drag()
          .on('start', this.dragstarted)
          .on('drag', this.dragged)
          .on('end', this.dragended)
      )
    }
  }
  buildElements() {
    const closeButton = document.createElement('div')
    closeButton.setAttribute('class', 'closeDetail')
    closeButton.addEventListener('click', () => {
      this.update(this.data)
      d3.select('body').classed('show_detail', false)
    })
    document.body.appendChild(closeButton)

    this.circles = this.nodes
      .append('circle')
      .classed('circle', true)
      .style('fill', (d, i) => {
        const cat = window.JMOSettings.category.find(c => c.id === d.category.id)
        return cat.color
      })

    this.images = this.nodes
      .append('image')
      .classed('thumbnail', true)
      .attr('xlink:href', (d, i) => {
        if(d.sku) {
          let thumbnail_url = '';
          if (fileTemplateUrl) {
            thumbnail_url = fileTemplateUrl.replace('FILENAME', `${d.sku}.png`);
            return thumbnail_url;
          }
        } else {
          return '';
        }
      })
    //icon image
    this.fragrance = this.nodes
      .append('image')
      .classed('fragrance', true)
      .classed('icon', true)
      .attr('xlink:href', (d, i) => {
        if(d.sku) {
          let fragrance_url = '';
          if (fileTemplateUrl) {
            fragrance_url = fileTemplateUrl.replace('FILENAME', `icon_${d.fragrance.id}.svg`);
            return fragrance_url;
          }
        } else {
          return '';
        }
      })
      .attr('width', d => {
        const frag_scale = d.fragrance.id === 'unscented' ? 0.75 : 1
        return FRAG_ICON_SIZE * frag_scale

      })
      .attr('height', d => {
        const frag_scale = d.fragrance.id === 'unscented' ? 0.75 : 1
        return FRAG_ICON_SIZE * frag_scale
      })

    const infowindowSize = is_sp() ? window.innerWidth * 0.933333333 : 480

    this.infoWindow = this.nodes
      .append('g')
      .classed('detail_wrapper', true)
      .attr('width', infowindowSize)
      .attr('height', infowindowSize)
      .attr('x', infowindowSize * -0.5)

      .append('foreignObject')
      .classed('detail', true)
      .attr('width', infowindowSize)
      .attr('height', infowindowSize)

    this.infoWindow
      .append('xhtml:div')
      .classed('detail_fragrance', true)
      .attr('data-fragrance', d => {
        return d.fragrance.id
      })
      .text(d => {
        return d.fragrance.name
      })
      .style('background-image', d => {
        return 'url(' + fileTemplateUrl.replace('FILENAME', `icon_${d.fragrance.id}.svg`) + ')'
      })

    this.infoWindow
      .append('xhtml:h2')
      .classed('detail_title', true)
      .text(d => {
        return d.name
      })
    this.infoWindow
      .append('xhtml:div')
      .classed('detail_text', true)
      .text(d => {
        const text = is_sp() ? (d.text).toString().substring(0, 54) + '…' : d.text
        return text
      })
    this.infoWindow
      .append('xhtml:a')
      .classed('detail_anchor', true)
      .attr('href', d => {
        return d.permalink
      })
      .attr('target', '_blank')
      .text('商品ページ')
  }

  updateParams(params) {
    this.params = is_sp() ? params.sp : params.pc
  }
  update(newData) {
    this.closeDetail()
    // update data
    this.data.maxMatched = newData.maxMatched
    this.data.children.forEach((d, index) => {
      const newMatched = newData.children[index].matched
      d.matched = newMatched

      // calc radius
      calcRadius(d, this.data.maxMatched, this.params)
    })

    // update nodes
    this.nodes.data(this.data.children, keyFunction).classed('hidden', d => {
      return d.matched < window.JMOSettings.chart.THRESHOLD
    })

    // update simulate
    this.simulate()

    this.draw()
  }
  draw() {
    this.circles
      .data(this.data.children, keyFunction)
      .transition()
      .duration(TRANSITION_DURATION)
      .attr('r', d => {
        return d.r
      })
      .attr('opacity', d => {
        return d.r === 0 ? 0 : 1
      })

    this.images
      .data(this.data.children, keyFunction)
      .transition()
      .duration(TRANSITION_DURATION)
      .attr('width', d => {
        return d.r * IMAGE_SCALE
      })
      .attr('height', d => {
        return d.r * IMAGE_SCALE
      })
      .attr('x', d => {
        return d.r * IMAGE_SCALE * -0.5
      })
      .attr('y', d => {
        return d.r * IMAGE_SCALE * -0.5
      })

    this.fragrance
      .data(this.data.children, keyFunction)
      .transition()
      .duration(TRANSITION_DURATION)
      .attr('x', d => {
        return FRAG_ICON_SIZE * -0.5
      })
      .attr('y', d => {
        return FRAG_ICON_SIZE * -0.5
      })
      .attr('transform', d => {
        const xy = d.r / 1.414213562 - FRAG_ICON_SIZE * d.r * 0.012
        return 'translate(' + [xy, xy] + ')'
      })
      .attr('opacity', d => {
        return d.matched > (is_sp() ? 80 : 15) ? 1 : 0
      })
  }
  onClick(clicked) {
    this.simulate()
    let ix, iy, ir, pr
    this.lastClicked = clicked

    d3.event.stopPropagation()
    if (clicked === this.selected) return

    d3.select('body').classed('show_detail', true)

    d3.select('.zoomed')
      .classed('beforeZoom', false)
      .classed('zoomed', false)

    const zoomedSize = is_sp() ? window.innerWidth * (350 / 750) : 240

    // let pr
    this.zoomAnim = d3
      .transition()
      .duration(800)
      .ease(d3.easeExpOut)
      .tween('start', () => {
        ix = d3.interpolateNumber(clicked.x, 0)
        iy = d3.interpolateNumber(clicked.y, 0)
        ir = d3.interpolateNumber(clicked.r, zoomedSize)

        if (this.selected) {
          this.selected.fx = null
          this.selected.fy = null
          pr = d3.interpolateNumber(zoomedSize, calculateRadius(this.selected, this.data.maxMatched, this.params))
          d3.select('#product_' + this.selected.sku).classed('leaveEnter', true)
        }

        d3.select('#product_' + clicked.sku).classed('beforeZoom', true)

        function is_sel(_clicked, d) {
          return d.sku === _clicked.sku
        }
        const selectedSize = is_sp() ? window.innerWidth * (128 / 375) : 200

        return t => {
          clicked.fx = ix(t)
          clicked.fy = iy(t)
          clicked.r = ir(t)

          if (this.selected) {
            this.selected.r = pr(t)
          }

          this.simulation
            .force(
              'collide',
              d3.forceCollide(d => d.r)
            )
            .on('tick', () => {
              this.nodes
                .attr('transform', d => {
                  return 'translate(' + [d.x, d.y] + ')'
                })
                .select('circle')
                .attr('r', d => {
                  return d.r
                })

              this.images
                .attr('width', d => {
                  return is_sel(clicked, d) ? selectedSize : d.r * IMAGE_SCALE
                })
                .attr('height', d => {
                  return is_sel(clicked, d) ? selectedSize : d.r * IMAGE_SCALE
                })
                .attr('x', d => {
                  return (is_sel(clicked, d) ? selectedSize : d.r * IMAGE_SCALE) * -0.5
                })
                .attr('y', d => {
                  return is_sel(clicked, d) ? selectedSize * -1 : d.r * IMAGE_SCALE * -0.5
                })
            })
        }
      })
      .on('end', () => {
        d3.select('#product_' + clicked.sku)
          .classed('beforeZoom', false)
          .classed('zoomed', true)

        if (this.selected) {
          d3.select('#product_' + this.selected.sku).classed('leaveEnter', false)
        }

        this.selected = clicked
      })
      .on('interrupt', () => {
        clicked.fx = null
        clicked.fy = null
        d3.select('.beforeZoom')
          .classed('beforeZoom', false)
          .classed('zoomed', false)

        if (this.selected) {
          d3.select('#product_' + this.selected.sku).classed('leaveEnter', false)
        }

        if (clicked === this.lastClicked) {
          this.selected = null
          return false
        } else {
          this.selected = clicked
        }
      })
  }
  closeDetail() {
    d3.selectAll('*').interrupt()
    if (!this.selected) return
    d3.select('body').classed('show_detail', false)

    d3.select('.beforeZoom, .zoomed')
      .classed('beforeZoom', false)
      .classed('zoomed', false)
    let pr
    this.selected.fx = null
    this.selected.fy = null
    d3.transition()
      .duration(500)
      .ease(d3.easeExpOut)
      .tween('start', () => {
        if (this.selected) {
          pr = d3.interpolateNumber(240, calculateRadius(this.selected, this.data.maxMatched, this.params))
          return t => {
            this.selected.r = pr(t)

            let forceCollide = d3.forceCollide(d => d.r)
            this.simulation.force('collide', forceCollide)
          }
        }
      })
      .on('end', () => {
        this.selected = null
      })
  }
}

export default D3_Chart
